<template>
  <div class="ele-body">
    <el-card shadow="never">
      <!-- 搜索表单 -->
      <el-form :model="table.where" label-width="77px" class="ele-form-search"
               @keyup.enter.native="$refs.table.reload()" @submit.native.prevent>
        <el-row :gutter="15">
            
            <el-col :md="6" :sm="12">
              <el-form-item label="保险名称:">
                <el-input v-model="table.where.title" placeholder="请输入保险名称" clearable/>
              </el-form-item>
            </el-col>
                                
                          <el-col :md="6" :sm="12">
            <div class="ele-form-actions">
              <el-button type="primary" @click="$refs.table.reload()" icon="el-icon-search" class="ele-btn-icon">查询
              </el-button>
              <el-button @click="(table.where={})&&$refs.table.reload()">重置</el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <!-- 操作按钮 -->
      <div class="ele-table-tool ele-table-tool-default">
        <el-button @click="showEdit=true" type="primary" icon="el-icon-plus" class="ele-btn-icon" size="small" v-if="permission.includes('sys:storesafe:add')">添加
        </el-button>
        <el-button @click="remove()" type="danger" icon="el-icon-delete" class="ele-btn-icon" size="small" v-if="permission.includes('sys:storesafe:dall')">批量删除
        </el-button>
      </div>
      <!-- 数据表格 -->
      <ele-data-table ref="table" :config="table" :choose.sync="choose" height="calc(100vh - 315px)" highlight-current-row>
        <template slot-scope="{index}">
          <el-table-column type="selection" width="45" align="center" fixed="left"/>
          <el-table-column type="index" :index="index" label="编号" width="60" align="center" fixed="left" show-overflow-tooltip/>
                  
          <el-table-column prop="title" label="保险名称"  show-overflow-tooltip min-width="120"/>
                                
          <el-table-column prop="classify" label="保险类型"  show-overflow-tooltip min-width="120"/>
                                
          <el-table-column prop="time" label="合作时间"  show-overflow-tooltip min-width="120"/>
                                
          <el-table-column prop="duty_name" label="负责人员"  show-overflow-tooltip min-width="120"/>
                                
          <el-table-column prop="phone" label="联系方式"  show-overflow-tooltip min-width="120"/>
                                          
          <el-table-column prop="status" label="状态"  :resizable="false" min-width="120">
              <template slot-scope="{row}">
                  <el-switch v-model="row.status" @change="status(row)" :active-value="1" :inactive-value="2"/>
              </template>
          </el-table-column>
          <el-table-column label="添加时间"  show-overflow-tooltip min-width="160">
            <template slot-scope="{row}">{{ row.create_time*1000 | toDateString }}</template>
          </el-table-column>
          <el-table-column label="操作" width="130px" align="center" :resizable="false"  fixed="right">
            <template slot-scope="{row}">
              <el-link @click="edit(row)" icon="el-icon-edit" type="primary" :underline="false" v-if="permission.includes('sys:storesafe:edit')">修改</el-link>
              <el-popconfirm title="确定要删除此保险合作吗？" @confirm="remove(row)" class="ele-action">
                <el-link slot="reference" icon="el-icon-delete" type="danger" :underline="false" v-if="permission.includes('sys:storesafe:delete')">删除</el-link>
              </el-popconfirm>
            </template>
          </el-table-column>
        </template>
      </ele-data-table>
    </el-card>
    <!-- 编辑弹窗 -->
    <el-dialog :title="editForm.id?'修改保险合作':'修改保险合作'" :visible.sync="showEdit" width="550px"
               @closed="editForm={}" :destroy-on-close="true" :lock-scroll="false">
      <el-form :model="editForm" ref="editForm" :rules="editRules" label-width="100px">
                          
        <el-form-item label="保险名称：" prop="title">
            <el-input v-model="editForm.title" placeholder="请输入保险名称" clearable/>
        </el-form-item>
                                                  
        <el-form-item label="保险类型：" prop="classify">
            <el-input v-model="editForm.classify" placeholder="请输入保险类型" clearable/>
        </el-form-item>
                                                  
        <el-form-item label="合作时间：" prop="time">
            <el-date-picker
                  v-model="editForm.time"
                  type="datetimerange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期">
                </el-date-picker>
        </el-form-item>
                                                      
        <el-form-item label="负责人员：" prop="duty_name">
            <el-input v-model="editForm.duty_name" placeholder="请输入负责人员" clearable/>
        </el-form-item>
                                                  
        <el-form-item label="联系方式：" prop="phone">
            <el-input v-model="editForm.phone" placeholder="请输入联系方式" clearable/>
        </el-form-item>
                                              
        <el-form-item label="状态：" prop="status">
          <el-switch
                  v-model="editForm.status"
                  active-text="开启"
                  inactive-text="关闭">
          </el-switch>
        </el-form-item>
        <el-form-item label="保单合同详情：" prop="content">
          <tinymce-editor v-model="editForm.content" :init="initEditor"/>
        </el-form-item>
                                          
      </el-form>
      <div slot="footer">
        <el-button @click="showEdit=false">取消</el-button>
        <el-button type="primary" @click="save">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
    import TinymceEditor from '@/components/TinymceEditor'
import { mapGetters } from "vuex";
export default {
  name: "SysStoreSafe",
  data() {
    return {
      table: {url: '/storesafe/index', where: {}},  // 表格配置
      choose: [],  // 表格选中数据
      showEdit: false,  // 是否显示表单弹窗
      editForm: {},  // 表单数据
      editRules: {  // 表单验证规则
                        
        title: [
          {required: true, message: '请输入保险名称', trigger: 'blur'}
        ],
                                    
        classify: [
          {required: true, message: '请输入保险类型', trigger: 'blur'}
        ],
                          
        time: [
          {required: true, message: '请输入合作时间', trigger: 'blur'}
        ],
                                    
        duty_name: [
          {required: true, message: '请输入负责人员', trigger: 'blur'}
        ],
                                    
        phone: [
          {required: true, message: '请输入联系方式', trigger: 'blur'}
        ],
                          
        status: [
          {required: true, message: '请选择状态', trigger: 'blur'}
        ],
                          
        content: [
          {required: true, message: '请输入保单合同详情', trigger: 'blur'}
        ],
              
      },
    }
  },
computed: {
    ...mapGetters(["permission"]),
    initEditor() {
      return {
        height: 400,
        file_picker_callback: this.file_picker_callback,
        skin_url: this.$store.state.theme.theme === 'dark' ? '/tinymce/skins/ui/oxide-dark' : '/tinymce/skins/ui/oxide',
        content_css: this.$store.state.theme.theme === 'dark' ? '/tinymce/skins/content/dark/content.css' : '/tinymce/skins/content/default/content.css',
        images_upload_handler: (blobInfo, success, error) => {
          let file = blobInfo.blob();
          // 使用axios上传
          const formData = new FormData();
          formData.append('file', file, file.name);
          this.$http.post('/upload/uploadImage', formData).then(res => {
            if (res.data.code == 0) {
              success(res.data.data);
            } else {
              error(res.data.msg);
            }
          }).catch(e => {
            console.error(e);
            error(e.message);
          });
        }
      };
    }
},
    components: {TinymceEditor},
  mounted() {
  },
  methods: {
    /**
     * 显示编辑
     */
    edit(row) {
      this.$http.get('/storesafe/info?id=' + row.id).then(res => {
        if (res.data.code === 0) {
          this.editForm = res.data.data;
          this.showEdit = true;
          this.editForm.status = this.editForm.status==1 ? true : false;
          this.editForm.time = this.editForm.time.split("/");
        } else {
          this.$message.error(res.data.msg);
        }
      }).catch(e => {
        this.$message.error(e.message);
      });
    },
    /**
     * 保存编辑
     */
    save() {
      this.$refs['editForm'].validate((valid) => {
        if (valid) {
          const loading = this.$loading({lock: true});
          this.editForm.time = this.formatDate(this.editForm.time[0])+'/'+this.formatDate(this.editForm.time[1]); 
          this.$http.post('/storesafe/edit', this.editForm).then(res => {
            loading.close();
            if (res.data.code === 0) {
              this.showEdit = false;
              this.$message({type: 'success', message: res.data.msg});
              this.$refs.table.reload();
            } else {
              this.$message.error(res.data.msg);
            }
          }).catch(e => {
            loading.close();
            this.$message.error(e.message);
          });
        } else {
          return false;
        }
      });
    },
    formatDate (d) {
       var date = new Date(d);
       var YY = date.getFullYear() + '-';
       var MM =
         (date.getMonth() + 1 < 10
           ? '0' + (date.getMonth() + 1)
           : date.getMonth() + 1) + '-';
       var DD = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
       var hh =
         (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
       var mm =
         (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) +
         ':';
       var ss =
         date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
       return YY + MM + DD + ' ' + hh + mm + ss;
     },
    /**
     * 刪除(批量刪除)
     */
    remove(row) {
      console.log(row)
      if (!row) {  // 批量删除
        if (this.choose.length === 0) return this.$message.error('请至少选择一条数据');
        let ids = this.choose.map(d => d.id);
        this.$confirm('确定要删除选中的保险合作吗?', '提示', {type: 'warning'}).then(() => {
          const loading = this.$loading({lock: true});
          this.$http.post('/storesafe/delete', {id: ids}).then(res => {
            loading.close();
            if (res.data.code === 0) {
              this.$message({type: 'success', message: res.data.msg});
              this.$refs.table.reload();
            } else {
              this.$message.error(res.data.msg);
            }
          }).catch(e => {
            loading.close();
            this.$message.error(e.message);
          });
        }).catch(() => 0);
      } else {  // 单个删除
        const loading = this.$loading({lock: true});
        this.$http.post('/storesafe/delete', {id:row.id}).then(res => {
          loading.close();
          if (res.data.code === 0) {
            this.$message({type: 'success', message: res.data.msg});
            this.$refs.table.reload();
          } else {
            this.$message.error(res.data.msg);
          }
        }).catch(e => {
          loading.close();
          this.$message.error(e.message);
        });
      }
    },
                          
    /**
     * 更改费用计算方式
     */
    status(row) {
        const loading = this.$loading({lock: true});
        let params = Object.assign({}, row);
        this.$http.post("/storesafe/status", params).then(res => {
            loading.close();
            if (res.data.code === 0) {
                this.$message({type: 'success', message: res.data.msg});
            } else {
                row.status = !row.status ? 2 : 1;
                this.$message.error(res.data.msg);
            }
        }).catch(e => {
            loading.close();
            this.$message.error(e.message);
        });
    },
        }
}
</script>

<style scoped>
.ele-block >>> .el-upload, .ele-block >>> .el-upload-dragger {
  width: 100%;
}
</style>